.VideoEmbedEditor {
	--field-padding-y: 0;
	--field-padding-x: 0;
	display: flex;
	flex-direction: column;
	grid-gap: 10px;
}
.VideoEmbedEditor__content {

}